import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useNavProject from '../../../hooks/useNavProject';
import useAPI from '../../../hooks/useAPI';
import BackBtn from '../../../components/UI/BackBtn';
import Reports from './WidgetPages/Reports';
import ArticlesTable from './WidgetPages/ArticlesTable';
import ProjectRequests from './WidgetPages/PortfRequests';
import { useStore } from '../../../stores/StoreHelpers';
import IncomesTable from './WidgetPages/IncomesTable';
import { hasPermsOnIndexesOrReceipts, isAdminReadRestricted, isCommandManagmentOrProjOffice, isProjectTeam } from '../../../services/rolesSvc';
import useUserContext from '../../../hooks/useUserContext';
import ForbiddenAccess from '../../../components/ForrbiddenAccessComponent/ForbiddenAccess';
import UnifiedPortfTable from "./WidgetPages/UnifiedPortfTable";
import MilestonesTable from '../../../components/project/Widgets/Milestones/MilestonesTable';
import Receipts from "../../../components/table/Receipts";

function PortfolioWidgetsPage() {
  const {
    stratId, portfolioId, projId, type,
  } = useParams();
  const navProject = useNavProject();
  const userCtx = useUserContext();
  const [navCtx, setNavCtx] = useState(null);
  const api = useAPI();
  const store = useStore();
  const canShow = (userCtx,stratId,projId,portfolioId)=>!!navCtx && (isCommandManagmentOrProjOffice(userCtx, stratId, projId, portfolioId) && !isProjectTeam(userCtx, projId))
  const canShowReports = (userCtx,stratId,projId,portfolioId) => canShow(userCtx,stratId,projId,portfolioId) || isAdminReadRestricted(userCtx)
  const content = [
    { type: 'reports', header: 'Реестр отчетов', show:canShowReports, content: <Reports />  },
    { type: 'articles', header: 'Статьи', show:canShow, content: <ArticlesTable navCtx={navCtx} portfName={navProject?.portfolioTitle ?? ''} />  },
    { type: 'incomes', header: 'Доходы', show:canShow, content: <IncomesTable navCtx={navCtx} portfName={navProject?.portfolioTitle ?? ''} />  },
    { type: 'requests', header: 'Заявки', show:canShow, content:  <ProjectRequests /> },
    { type: 'unified', content:  <UnifiedPortfTable />, show: () => hasPermsOnIndexesOrReceipts(userCtx, {stratId, portfolioId}) },
    { type: 'milestones', content:  <MilestonesTable/>,},
    { 
      type: 'receipts', 
      content:  
      <Receipts 
        portfolioId={portfolioId} 
        tableLeftValues={[224, 454]}
        type={'portfolioReceipts'}
        totalIndex={2}
      />
    },
  ];

  useEffect(() => {
    store.articles.clearStoreOnCardExit();
  }, []);

  useEffect(async () => {
    if (portfolioId) {
      const respPortfolio = await api.get(`/structure/portfolios/${portfolioId}?latest=true`);
      if (!respPortfolio || respPortfolio.error) return;

      setNavCtx({ strategy: respPortfolio.strategy, portfolio: respPortfolio });
      navProject.setStratTitle(respPortfolio.strategy.name);
      navProject.setPortfolioTitle(respPortfolio.name);
    }
  }, []);

  return (
    <section className="page project-page">
      <div className="container">
        <BackBtn />
        {content.filter((x) => x.type === type)[0]?.header &&
            <div className="project-title-wrapper" style={{ paddingBottom: '0', color: '#0C0065' }}>
              <h2>{content.filter((x) => x.type === type)[0]?.header}</h2>
            </div>}
        <div>
          {content.filter((x) => x.type === type && (!x.show || x.show(userCtx, stratId, projId, portfolioId)))[0]?.content ?? <ForbiddenAccess />}
        </div>
      </div>
    </section>
  );
}

export default PortfolioWidgetsPage;
